






















































































































import { Vue, Component, Prop } from "vue-property-decorator";
import {
  ABSORPTION_DATABASE,
  CreateMaterialRequest,
  Material,
  MaterialDB,
  ScatteringDB,
  SCATTERING_DATABASE
} from "@/res/materials-absorption";

@Component({
  components: {}
})
export default class MaterialInputAdd extends Vue {
  @Prop({ type: String })
  materialType!: "absorption" | "scattering";
  private dialog: boolean = false;
  private type: "New" | "Edit" = "New";
  private Hz: string[] = ["62.5", "125", "250", "500", "1k", "2k", "4k", "8k"];
  public mat: CreateMaterialRequest = {
    title: "",
    values: [0, 0, 0, 0, 0, 0, 0, 0],
    description: "",
    source: ""
  } as CreateMaterialRequest;
  private values: string[] = Array(8).fill("");

  get materialLabel(): string {
    return this.materialType === "absorption" ? "Absorption" : "Scattering";
  }

  async addCustomMaterial() {
    if (!this.formIsValid()) return;
    this.dialog = false;
    const paddedValues = [...this.values.map(v => +v), 0, 0, 0, 0].slice(0, 8);

    const newMaterial: CreateMaterialRequest = {
      title: this.mat.title,
      values: paddedValues as [
        number,
        number,
        number,
        number,
        number,
        number,
        number,
        number
      ],
      description: this.mat.description,
      source: this.mat.source,
      uuid: this.mat.uuid
    };

    let response: any;
    if (this.materialType === "absorption") {
      if (this.type === "New") {
        response = await MaterialDB.addMaterial(newMaterial);
        if (response) {
          MaterialDB.add_ABSORPTION_MATERIAL(response);
          ABSORPTION_DATABASE.set(response.uuid, response);
        }
      } else {
        response = await MaterialDB.updateMaterial(
          newMaterial,
          newMaterial.uuid
        );
        if (response) {
          MaterialDB.add_ABSORPTION_MATERIAL(response);
          ABSORPTION_DATABASE.set(response.uuid, response);
        }
      }
    } else {
      if (this.type === "New") {
        response = await ScatteringDB.addScattering(newMaterial);
        if (response) {
          ScatteringDB.add_SCATTERING_MATERIAL(response);
          SCATTERING_DATABASE.set(response.uuid, response);
        }
      } else {
        response = await ScatteringDB.updateScattering(
          newMaterial,
          newMaterial.uuid
        );
        if (response) {
          ScatteringDB.add_SCATTERING_MATERIAL(response);
          SCATTERING_DATABASE.set(response.uuid, response);
        }
      }
    }
    this.$emit("refreshMaterialList", response.uuid);
    this.resetForm();
  }

  form = () =>
    this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => null;
      resetValidation: () => null;
    };

  formIsValid() {
    return this.form().validate();
  }

  resetForm() {
    if (this.form()) {
      this.form().reset();
      this.form().resetValidation();
    }
  }

  openNewMaterial() {
    this.type = "New";
    this.dialog = true;
    this.resetForm();
  }

  openEditMaterial(mat: Material) {
    this.type = "Edit";
    this.dialog = true;
    this.mat = { ...mat };
    this.values = Array.from(mat.values.map(v => v.toString()));
  }

  close() {
    this.resetForm();
    this.dialog = false;
  }

  data() {
    return {
      currentMaterialID: 0,
      valid: false,
      titleRules: [
        (v: any) => !!v || "Name is required",
        (v: any) =>
          (v && v.length <= 80) || "Name must be less than 80 characters"
      ],
      descriptionRules: [
        (v: any) => !!v || "Description text is required",
        (v: any) =>
          (v && v.length <= 255) ||
          "Description must be less than 256 characters"
      ],
      sourceRules: [
        (v: any) => !!v || "Source reference is required",
        (v: any) =>
          (v && v.length <= 80) ||
          "Source reference text must be less than 80 characters"
      ],
      valuesRules: [
        (v: any) => !!v || "0-1",
        (v: any) => (v && v >= 0 && v <= 1) || "0-1",
        (v: any) => (v && v.length <= 6) || "<6"
      ]
    };
  }
}
